// بيانات الصوت لإذاعة جامعة زايد العسكرية
// استخدام ملفات صوتية محلية من مجلد assest/audio
import track1 from '../assest/audio/1.mp3';
import track2 from '../assest/audio/2.mp3';
import rest1 from '../assest/audio/rest1.mp3';
import rest2 from '../assest/audio/rest2.mp3';
import rest3 from '../assest/audio/rest3.mp3';
import anaAlAlam from '../assest/audio/تحميل-اغنية-أنا-العلم-بلقيس-فتحي.mp3';
import yaAmelna from '../assest/audio/تحميل-اغنية-يا-عملنا-بلقيس-فتحي-وحسين-الجسمي.mp3';
import yaAmelnaKids from '../assest/audio/تحميل-اغنية-يا-عملنا-للأطفال.mp3';
import yahyaAlam from '../assest/audio/تحميل-اغنية-يحيا-علم-اليوم-يومك-يا-علم.mp3';
import eishiBiladi from '../assest/audio/عيشي بلادي.mp3';

// استيراد ديناميكي للملفات من المجلدات
const audioContext = require.context('../assest/audio', true, /\.mp3$/);

// تسجيل جميع الملفات المتوفرة للتصحيح
console.log('All audio files found:', audioContext.keys());

// إنشاء خريطة لتخزين الملفات
const audioFiles = {};
audioContext.keys().forEach(key => {
  const fileName = key.replace(/^.*[\\/]/, '').replace('.mp3', '');
  audioFiles[fileName] = audioContext(key);
});

export const audioData = [
  // أغاني مهداة للشيوخ (1)
  ...(audioContext.keys().filter(k => {
    const matches = k.includes('اغاني مهداة للشيوخ');
    if (matches) console.log('Sheikh song found:', k);
    return matches;
  }).map((key, idx) => {
    const fileName = key.replace(/^.*[\\/]/, '').replace('.mp3', '');
    console.log('Adding sheikh song:', fileName);
    return {
      id: 100 + idx,
      titleAr: fileName,
      duration: "3:45",
      url: audioContext(key),
      category: "music",
      description: "أغنية مهداة للشيوخ",
      libraryCategoryId: 1
    };
  })),
  // أغاني وطنية (2)
  ...(audioContext.keys().filter(k => {
    const matches = k.includes('Aghani Wataniyah') || k.includes('أهل الشيم');
    if (matches) console.log('Watani song found:', k);
    return matches;
  }).map((key, idx) => {
    const fileName = key.replace(/^.*[\\/]/, '').replace('.mp3', '');
    console.log('Adding watani song:', fileName);
    return {
      id: 200 + idx,
      titleAr: fileName,
      duration: "3:45",
      url: audioContext(key),
      category: "music",
      description: "أغنية وطنية",
      libraryCategoryId: 2
    };
  })),
  // أغاني الشهيد (3)
  ...(audioContext.keys().filter(k => {
    const matches = k.includes('شهيد');
    if (matches) console.log('Shaheed song found:', k);
    return matches;
  }).map((key, idx) => {
    const fileName = key.replace(/^.*[\\/]/, '').replace('.mp3', '');
    console.log('Adding shaheed song:', fileName);
    return {
      id: 300 + idx,
      titleAr: fileName,
      duration: "3:45",
      url: audioContext(key),
      category: "music",
      description: "أغنية الشهيد",
      libraryCategoryId: 3
    };
  })),
   {
    id: 6,
    titleAr: " أهل الشيم",
    duration: "3:50",
    url: eishiBiladi,
    category: "music",
    description: "أغنية وطنية إماراتية",
    libraryCategoryId: 2
  },
  {
    id: 3,
    titleAr: " زايد و راشد - من أشعار صاحب السمو الشيخ محمد بن راشد أل مكتوم والحان ملحن الوطن محمد الاحمد",
    duration: "3:50",
    url: eishiBiladi,
    category: "music",
    description: "أغنية وطنية إماراتية",
    libraryCategoryId: 2
  },
    {
    id: 3,
    titleAr: " قصة الإمارات - علي الخوار - فايز السعيد - حسين الجسمي-01",
    duration: "3:50",
    url: eishiBiladi,
    category: "music",
    description: "أغنية وطنية إماراتية",
    libraryCategoryId: 2
  },
      {
    id: 3,
    titleAr: " أغنية عز الوطن .. إهداء إلى مقام سيدي صاحب السمو الشيخ محمد بن زايد آل نهيان",
    duration: "3:50",
    url: eishiBiladi,
    category: "music",
    description: "أغنية وطنية إماراتية",
    libraryCategoryId: 1
  },
      {
    id: 3,
    titleAr: " قصة الإمارات - علي الخوار - فايز السعيد - حسين الجسمي-الرئاسة - اهداء إلى صاحب السمو الشيخ محمد بن زايد آل نهيان-رئيس الدولة",
    duration: "3:50",
    url: eishiBiladi,
    category: "music",
    description: "أغنية وطنية إماراتية",
    libraryCategoryId: 1
  },
      {
    id: 3,
    titleAr: " قصة الإمارات - علي الخوار - فايز السعيد - حسين الجسمي-عزنا محمد - من أشعار سمو الشيخ منصور بن زايد آل نهيان و إخراج موسيقي  محمد الأحمد _ 2024",
    duration: "3:50",
    url: eishiBiladi,
    category: "music",
    description: "أغنية وطنية إماراتية",
    libraryCategoryId: 1
  },
  // الأغاني القديمة
/*   {
    id: 6,
    titleAr: "عيشي بلادي",
    duration: "3:50",
    url: eishiBiladi,
    category: "music",
    description: "أغنية وطنية إماراتية",
    libraryCategoryId: 2
  },
  {
    id: 2,
    titleAr: "أنا العلم - بلقيس فتحي",
    duration: "3:45",
    url: anaAlAlam,
    category: "music",
    description: "النشيد الوطني لبلقيس فتحي",
    libraryCategoryId: 2
  },
  {
    id: 3,
    titleAr: "يا عملنا - بلقيس فتحي وحسين الجسمي",
    duration: "4:20",
    url: yaAmelna,
    category: "music",
    description: "أغنية وطنية بالتعاون بين فنانين",
    libraryCategoryId: 2
  },
  {
    id: 4,
    titleAr: "يا عملنا للأطفال",
    duration: "3:30",
    url: yaAmelnaKids,
    category: "music",
    description: "نسخة الأطفال من يا عملنا",
    libraryCategoryId: 2
  },
  {
    id: 5,
    titleAr: "يحيا علم اليوم يومك يا علم",
    duration: "4:00",
    url: yahyaAlam,
    category: "music",
    description: "أغنية احتفال بالعلم الوطني",
    libraryCategoryId: 2
  },
  {
    id: 7,
    titleAr: "المقطع الأول",
    duration: "3:15",
    url: track1,
    category: "music",
    description: "مقطع موسيقي إضافي",
    libraryCategoryId: 1
  },
  {
    id: 8,
    titleAr: "المقطع الثاني",
    duration: "3:40",
    url: track2,
    category: "music",
    description: "مقطع موسيقي إضافي",
    libraryCategoryId: 2
  } */
];

// الفواصل المقترحة
export const restTracks = [
  {
    id: "rest-1",
    titleAr: "زايد الأرث",
    duration: "0:30",
    url: rest1,
    category: "rest",
    description: "يركز على إرث زايد الإنساني والوطني والممتد حتى اليوم في الشباب والوطن"
  },
  {
    id: "rest-2", 
    titleAr: "روح الوطنية",
    duration: "0:30",
    url: rest2,
    category: "rest",
    description: "فاصل تحفيزي يومي يرفع من روح الوطنية ويعزز المواطنة الصالحة"
  },
  {
    id: "rest-3",
    titleAr: "نحتفل للوطن", 
    duration: "0:30",
    url: rest3,
    category: "rest",
    description: "مشاركة الجامعة المجتمع بأي إنجاز تحققه الدولة"
  },
  {
    id: "rest-4",
    titleAr: "صوتنا قوتنا", 
    duration: "0:30",
    url: rest1,
    category: "rest",
    description: "تصاريح سريعة لعدد من الإداريين والأكاديميين وحتى الطلبة"
  }
];

// بيانات البث المباشر
export const liveStream = {
  id: "live-1",
  titleAr: "إذاعة جامعة زايد العسكرية",
  url: track1,
  isLive: true,
  description: "البث المباشر لإذاعة جامعة زايد العسكرية - احتفالاً بالعيد الوطني 54",
  image: require('../assest/New folder/54-national-day-united-arab-260nw-2363778695.webp')
};
